import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "MyProductList" })
export default class MyProductList extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public products: any[] = [];
    public filterMode: string = null;

    @Prop() readonly returnUrl: string;

    get isGenuineProductFormVisible() {
        return this.$store.getters["myProductStore/isGenuineProductFormVisible"];
    }

    get isCatalogueSearchHide() {
        return this.$store.getters["catalogueSearchStore/isCatalogueSearchHide"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("isGenuineProductFormVisible") async onIsGenuineProductFormVisibleChanged(newValue: boolean) {
        if (!newValue && this.filterMode === "GenuineProducts") {
            await this.getGenuineProducts();
        }
    }

    public async mounted() {
        this.filterMode = "Products";
        await this.setFilter("Products");
    }

    public async setFilter(mode: string) {
        switch (mode) {
            case "Products":
                this.filterMode = "Products";
                await this.getFavoriteProducts();
                break;
            case "GenuineProducts":
                this.$store.commit("catalogueSearchStore/setCatalogueSearchHidden", true);
                this.filterMode = "GenuineProducts";
                await this.getGenuineProducts();
                break;
            case "AddGenuineProduct":
                this.showGenuineProductForm();
                break;
        }
    }

    public async getFavoriteProducts() {
        this.isLoading = true;
        this.products = (await Axios.post(this.routes.MyBremboPartsProduct_GetProducts, null)).data;
        this.isLoading = false;
    }

    public async getGenuineProducts() {
        this.isLoading = true;
        this.products = (await Axios.post(this.routes.MyBremboPartsProduct_GetGenuineProducts, null)).data;
        this.isLoading = false;
    }

    public showGenuineProductForm() {
        this.$store.commit("myProductStore/setGenuineProductFormVisible", true);
    }

    public addFavorite() {
        this.$store.commit("catalogueSearchStore/setCatalogueSearchHidden", false);
        this.$store.commit("catalogueSearchStore/setCatalogueSearchMode", "Code");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    public setAnalytics(bremboCode: string) {
        GTagHelper.sendCustomEvent("file_download", { genuine: "download_certificate", genuine_certificate_code: bremboCode });
    }
};